@if (model) {
    <div>
        @if (!isLoading) {
            <div>
                <incident-linkable
                    #linkable
                    data-uiid="thirdparty-incidentlinkable"
                    typename="Incidents"
                    displayValueProp="name"
                    [linked]="linked"
                    [unlinked]="[]"
                    [hideActions]="true"
                    [orderByValueProperty]="true"
                    [disabled]="disabled"
                >
                </incident-linkable>
            </div>
        } @else {
            <div>
                <div class="fancy-loader"></div>
            </div>
        }
    </div>
}
